<div class="consultar-contas-pagar-container">
  <div class="header d-flex justify-content-between align-items-center">
    <h1>Contas a Pagar</h1>
    <button type="button" class="btn btn-primary" (click)="novo()">
      <i class="fa fa-plus"></i> Adicionar novo
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3">
      <div class="col-md-3">
        <label class="form-label">Documento</label>
        <select class="form-control" [(ngModel)]="filtroIdFinDocumento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let item of documentos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Parcela</label>
        <input type="number" class="form-control" [(ngModel)]="filtroParcela" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Fornecedor</label>
        <select class="form-control" [(ngModel)]="filtroIdFinFornecedorRecebedor">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let item of fornecedores" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Data Emissão</label>
        <input type="date" class="form-control" [(ngModel)]="filtroDataEmissao" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Data Vencimento</label>
        <input type="date" class="form-control" [(ngModel)]="filtroDataVencimento" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Data Pagamento</label>
        <input type="date" class="form-control" [(ngModel)]="filtroDataPagamento" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Tipo Pagamento</label>
        <select class="form-control" [(ngModel)]="filtroIdTipoPagamento">
          <option [ngValue]="0">Todos</option>
          <option *ngFor="let item of tiposPagamento" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-7">
        <label class="form-label">Observações</label>
        <input type="text" class="form-control" [(ngModel)]="filtroObservacao" />
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
        <i class="fa fa-eraser"></i> Limpar
      </button>
      <button type="button" class="btn btn-primary" (click)="buscar()">
        <i class="fa fa-search"></i> Buscar
      </button>
    </div>
  </div>

  <div class="card-box">
    <div class="previsao-real-legenda">
      <span class="previsao-real-legenda__titulo">Legenda:</span>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--todos" [class.ativo]="filtroPrevisaoReal === 'T'" (click)="filtrarPorPrevisaoReal('T')">Todos</button>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--previsao" [class.ativo]="filtroPrevisaoReal === 'P'" (click)="filtrarPorPrevisaoReal('P')">Previsão</button>
      <button type="button" class="previsao-real-legenda__item previsao-real-legenda__item--real" [class.ativo]="filtroPrevisaoReal === 'R'" (click)="filtrarPorPrevisaoReal('R')">Real</button>
    </div>

    <div
      #tabelaScroll
      class="table-responsive"
      [class.dragging-table]="arrastandoTabela"
      (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
      (mousemove)="moverArrasteTabela($event, tabelaScroll)"
      (mouseup)="encerrarArrasteTabela()"
      (mouseleave)="encerrarArrasteTabela()">
      <table class="table table-striped table-hover align-middle">
        <thead>
          <tr>
            <th>#</th>
            <th>Fornecedor</th>
            <th>Documento</th>
            <th>Parcela</th>
            <th>Data Emissão</th>
            <th>Data Vencimento</th>
            <th>Data Pagamento</th>
            <th>Vlr. Título</th>
            <th>Vlr. Pago</th>
            <th>Centro de Custos</th>
            <th>Plano de Contas</th>
            <th>Pago</th>
            <th>Tipo Pagamento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of itensPaginados; let i = index"
            [ngClass]="item.previsaoReal === 'P' ? 'linha-previsao' : 'linha-real'">
            <td>{{ ((paginaAtual - 1) * itensPorPagina) + i + 1 }}</td>
            <td>{{ item.finFornecedorRecebedor || '-' }}</td>
            <td>{{ item.finDocumento || '-' }}</td>
            <td>{{ item.parcela || '-' }}</td>
            <td>{{ item.dataEmissao }}</td>
            <td>{{ item.dataVencimento }}</td>
            <td>{{ item.dataPagamento }}</td>
            <td>{{ item.valorDocumento != null ? item.valorDocumento.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' }}</td>
            <td>{{ item.valorPago != null ? item.valorPago.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' }}</td>
            <td>{{ item.centroCusto || '-' }}</td>
            <td>{{ item.planoContas || '-' }}</td>
            <td>
              <span class="badge" [ngClass]="item.pago ? 'badge-success' : 'badge-warning'">
                {{ item.pago ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>{{ item.tipoPagamento || '-' }}</td>
            <td>
              <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-outline-primary" title="Editar" (click)="editar(item)">
                  <i class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn btn-outline-success" title="Pagamento" (click)="pagamento(item)">
                  <i class="fas fa-money-bill-wave"></i>
                </button>
                <button type="button" class="btn btn-outline-danger" title="Excluir" (click)="deletar(item)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!loading && itensPaginados.length === 0">
            <td colspan="14" class="text-center py-4">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-wrapper mt-3">
      <div class="d-flex align-items-center gap-2">
        <label class="m-0">Itens por página:</label>
        <select class="form-control form-control-sm page-size-select" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual <= 1" (click)="paginaAnterior()">
          <i class="fa fa-chevron-left"></i> Anterior
        </button>
        <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button class="btn btn-outline-secondary btn-sm" [disabled]="paginaAtual >= totalPaginas" (click)="proximaPagina()">
          Próxima <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
